import React, { Component } from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import SendIcon from '@mui/icons-material/Send';
import IconButton from '@mui/material/IconButton';
import './comment.css'
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import Button from '@mui/material/Button';
import authStore from '../../../Auth/AuthStore'
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import mainStore from '../../../../MainStore';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import DeleteIcon from '@mui/icons-material/Delete';
import { Checkbox, FormControlLabel } from '@mui/material';
import ReactTextFormat from 'react-text-format';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default class CommentBlock extends Component {
    constructor(props) {
        super(props);
        this.state = {
            comment: '',
            editComment: '',
            comments: [],
            files: [],
            dialogFiles: [],
            commentId: '',
            sessionId: this.uuidv4(),
            isCommentEdited: false,
            isShowSystemComments: localStorage.getItem('isShowSystemComments') === 'true'
        };

        this.myRef = React.createRef();
        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleCommentChange = this.handleCommentChange.bind(this);
        this.editComment = this.editComment.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleFileUpload = this.handleFileUpload.bind(this);
        this.handleAttacheFile = this.handleAttacheFile.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleIsShowSystemComments = this.handleIsShowSystemComments.bind(this);
        this.load = this.load.bind(this);
    }

    componentWillMount() {
        this.load();
    }

    componentWillUnmount() {
        this.props.handleParentChange({ "comment": "" });
    }

    load() {
        if (!this.props.workId) return;
        let scope = this;
        mainStore.setMaskVisible();
        fetch('api/Work/GetComment?workId=' + this.props.workId + '&sessionId=' + (!!this.props.sessionId ? this.props.sessionId: '') + '&isShowSystemComments=' + this.state.isShowSystemComments, {
            method: 'GET',
            body: null,
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    mainStore.setMaskUnvisible();
                    scope.setState({ comments: result });
                }).catch((err) => console.log(err));
            }
        });
    }

    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    handleCommentChange(data) {
        this.setState({ "comment": data });

        if (this.props.handleParentChange) {
            this.props.handleParentChange({ "comment": data });
        }
    }

    handleChange = name => evt => {
        this.setState({ [name]: evt.target.value });

        if (this.props.handleParentChange) {
            this.props.handleParentChange({ [name]: evt.target.value });
        }
    }

    handleIsShowSystemComments(evt) {
        var isShowSystemComments = evt.target.checked;
        localStorage.setItem('isShowSystemComments', isShowSystemComments);
        this.setState({ isShowSystemComments: isShowSystemComments }, () => this.load());
    }

    handleAttacheFile() {
        this.myRef.current.click()
    }

    handleDelete = (id, isNew) => evt => {
        this.setState({ isInLoading: true });
        var scope = this;
        var token = localStorage.getItem("token");
        fetch('api/Work/DeleteAttachment', {
            method: 'POST',
            body: JSON.stringify({ fileId: id }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                authStore.openLogin();
                scope.setState({ isInLoading: false });
            }
            else {
                if (res.status === 200) {
                    if (isNew) {
                        var files = scope.state.files;
                        var dialogFiles = scope.state.dialogFiles;
                        files.splice(files.findIndex(f => f.id === id), 1);
                        dialogFiles.splice(dialogFiles.findIndex(f => f.id === id), 1);
                        scope.setState({ files: files, isInLoading: false, dialogFiles: dialogFiles });
                    }
                    else {
                        var comments = scope.state.comments.slice(0);
                        var commentIndex = comments.findIndex(c => c.files.findIndex(f => f.id === id) > -1);
                        comments[commentIndex].files.splice(comments[commentIndex].files.findIndex(f => f.id === id), 1);
                        scope.setState({ comments: comments, isInLoading: false});
                    }
                }
                else {
                    console.log(res);
                    alert('error');
                }
            }
        });
    }

    handleFileUpload(e) {
        this.setState({ isInLoading: true });
        var files = e.target.files;
        var token = localStorage.getItem("token");
        var data = new FormData();
        var scope = this;
        for (var i = 0; i < files.length; i++) {
            data.append('file', files.item(i));
        };

        var methodName = 'AddCommentAttachments';

        if (!this.state.commentId) {
            methodName = 'AddTempAttachments';
            data.append('sessionId', this.state.sessionId);
        }
        else {
            data.append('commentId', this.state.commentId);
        }

        fetch('api/Work/' + methodName, {
            method: 'POST',
            body: data,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                authStore.openLogin();
                scope.setState({ isInLoading: false });
            }
            else {
                res.json().then((result) => {
                    scope.setState({ files: result.concat(scope.state.files), dialogFiles: result.concat(scope.state.dialogFiles), isInLoading: false });
                }).catch((err) => console.log(err));
            }
        });
    }

    handleSave() {
        var scope = this;
        if (!this.state.comment && !this.state.editComment && (this.state.files == null || this.state.files.length < 1) && (this.state.dialogFiles == null || this.state.dialogFiles.length < 1)) return;
        mainStore.setMaskVisible();
        var token = localStorage.getItem("token");
        fetch('api/Work/AddComment', {
            method: 'POST',
            body: JSON.stringify({ Text: this.state.comment, WorkId: this.props.workId, SessionId: this.props.sessionId, commentId: this.state.commentId, editComment: this.state.editComment, FileSessionId: this.state.sessionId }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                authStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    var comments = scope.state.comments.slice(0);
                    var index = comments.findIndex(c => c.id === result.id)
                    if (index > -1) {
                        comments.splice(index, 1, result);
                    }
                    else {
                        comments.push(result);
                    }
                    mainStore.setMaskUnvisible();
                    scope.setState({ comments: comments, comment: '', commentId: '', isCommentEdited: false, editComment: '', sessionId: scope.uuidv4(), files: [], dialogFiles: [] });
                    if (scope.props.handleParentChange) {
                        scope.props.handleParentChange({ 'comment': '' });
                    }
                }).catch((err) => console.log(err));
            }
        });
    }

    editComment = comment => () => {
        this.setState({ commentId: comment.id, editComment: comment.text, isCommentEdited: true, dialogFiles: comment.files });
    }

    handleClose() {
        this.setState({ commentId: '', isCommentEdited: false, editComment: '' });
    }

    render() {
        var comments = this.state.comments && this.state.comments.map(c =>
            <Card key={c.id} className="comment-card">
                <CardContent>
                    <Typography color="textSecondary" gutterBottom>
                        {c.userName} {c.isEdited ? "edit at" : "at"} {c.isEdited ? c.editDate : c.date} {authStore.getUserId === c.userId && <IconButton onClick={this.editComment(c)} size="large"><EditIcon /></IconButton>}
                    </Typography>
                    <Typography variant="body2" component="span">
                        {c.text && c.text.split('\n') && c.text.split('\n').map(t => t === '' ? <div/> : <div key={t}> <ReactTextFormat allowedFormats={['URL', 'Email', 'Image', 'Phone', 'CreditCard']} linkTarget="_blank">{t}</ReactTextFormat></div>)}
                    </Typography>
                    {c.files && c.files.map(f => <div key={f.id} className="small-file-item"><span><a download href={"api/Work/GetCommentFile?fileId=" + f.id}>{f.name}</a></span>
                        {authStore.getUserId === c.userId && <IconButton
                            className="small-icon-button"
                            aria-label="Удалить"
                            onClick={this.handleDelete(f.id, false)}
                            size="large">
                            <DeleteIcon />
                        </IconButton>}
                    </div>)}
                </CardContent>
                {false && <CardActions>
                    <Button size="small">Edit</Button>
                </CardActions>}
            </Card>);

        var files = this.state.files && this.state.files.map && this.state.files.map(f =>
            <div key={f.id} className="small-file-item"><span><a download href={"api/Work/GetFile?fileId=" + f.id}>{f.name}</a></span>
                <IconButton
                    className="small-icon-button"
                    aria-label="Удалить"
                    onClick={this.handleDelete(f.id, true)}
                    size="large">
                    <DeleteIcon />
                </IconButton>
            </div>);

        return (
            <div className="full-width">
                <div>
                    <FormControlLabel
                        control={
                            <Checkbox checked={this.state.isShowSystemComments} onChange={this.handleIsShowSystemComments} value="true" />
                        }
                        label="Показывать системные сообщения"
                    />
                </div>
                <div className={"comment-list-wrapper " + ( this.props.isFullView ? "full-view-fixed-heigth" : "fixed-heigth" )}>
                    {comments}
                </div>
                <input type="file" name="file" multiple hidden onChange={this.handleFileUpload} ref={this.myRef} />
                <TextField required
                    id="standard-required"
                    label="Новый комментарий"
                    fullWidth
                    margin="normal"
                    value={this.state.comment}
                    multiline
                    onKeyDown={(e) => e.keyCode === 13 && e.ctrlKey && this.handleSave()}
                    onChange={this.handleChange('comment')}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton size="small" onClick={this.handleAttacheFile}>
                                    <AttachFileIcon />
                                </IconButton>
                                <IconButton size="small" onClick={this.handleSave}>
                                    <SendIcon />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
                {files}

                <Dialog
                    TransitionComponent={Transition}
                    keepMounted
                    maxWidth="lg"
                    onClose={this.handleClose} aria-labelledby="simple-dialog-title" open={this.state.isCommentEdited}>
                    <div className="edit-comment-dialog-inner">
                        <TextField required
                            id="standard-required"
                            label="Редактирование комментария"
                            fullWidth
                            margin="normal"
                            value={this.state.editComment}
                            multiline
                            onKeyDown={(e) => e.keyCode === 13 && e.ctrlKey && this.handleSave()}
                            onChange={this.handleChange('editComment')}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton size="small" onClick={this.handleAttacheFile}>
                                            <AttachFileIcon />
                                        </IconButton>
                                        <IconButton size="small" onClick={this.handleSave}>
                                            <SendIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </div>
                    <div className="comment-dialog-file-panel">{this.state.dialogFiles && this.state.dialogFiles.map && this.state.dialogFiles.map(f =>
                        <div key={f.id} className="small-file-item"><span><a download href={"api/Work/GetFile?fileId=" + f.id}>{f.name}</a></span>
                            <IconButton
                                className="small-icon-button"
                                aria-label="Удалить"
                                onClick={this.handleDelete(f.id, true)}
                                size="large">
                                <DeleteIcon />
                            </IconButton>
                        </div>)}
                    </div>
                </Dialog>
            </div>
        );
    }
}
